import _defineProperty from "/opt/buildhome/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { genComponentStyleHook } from '../../theme/internal';
import genSpaceCompactStyle from './compact';

var genSpaceStyle = function genSpaceStyle(token) {
  var componentCls = token.componentCls;
  return _defineProperty({}, componentCls, _defineProperty({
    display: 'inline-flex',
    '&-rtl': {
      direction: 'rtl'
    },
    '&-vertical': {
      flexDirection: 'column'
    },
    '&-align': {
      flexDirection: 'column',
      '&-center': {
        alignItems: 'center'
      },
      '&-start': {
        alignItems: 'flex-start'
      },
      '&-end': {
        alignItems: 'flex-end'
      },
      '&-baseline': {
        alignItems: 'baseline'
      }
    }
  }, "".concat(componentCls, "-item:empty"), {
    display: 'none'
  }));
}; // ============================== Export ==============================


export default genComponentStyleHook('Space', function (token) {
  return [genSpaceStyle(token), genSpaceCompactStyle(token)];
}, function () {
  return {};
}, {
  // Space component don't apply extra font style
  // https://github.com/ant-design/ant-design/issues/40315
  resetStyle: false
});